// File: km-pod-interface.js
// Author: King & McGaw (web@kingandmcgaw.com)
// Requirements:
//    jQuery (included by theme.liquid)
//      - current version 1.11.0 (out of date/vulnerable) see: https://snyk.io/test/npm/jquery/1.11.0
//    lodash.js (included by product.kmpod.liquid)
//      - current version 4.17.15 (up to date as of 22/12/2020)
//      - https://lodash.com/docs/4.17.15
//
// Description:
//    This file runs after Shopify option_selection.js does it's magic
//    To start, a single <select> is output to the html from product.kmpod.liquid
//    option_selection.js is a Shopify lib that converts that into 3 individual <select>s based on the available options
//    Finally this script replaces the 3rd <select> with a list of frame option links
//
// NB: even though this is an `object`, it does not maintain state of any kind. It's just a bag of namespaced functions.
// It also uses 3 global variables (yuk). see product.kmpod.liquid.

var KMPod = {
  frameOptions: {
    none: {
      image: 'https://img.kingandmcgaw.com/i/frames/no_frame.jpg',
      title: 'No frame'
    },
    black: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880229.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Black stained ash'
    },
    natural: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880232.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Natural ash waxed box'
    },
    white: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880231.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'White painted ash box'
    },
    gold: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880242.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Gold cushion'
    }
  },

  initialize: function () {
    KMPod.generateFrameOptions()
  },

  generateFrameOptions: function () {
    console.log('generateFrameOptions...')
    var pickerHtml = _.map(window.productVariants, function (variant) {
      var podMedia = variant.option1
      var podSize = variant.option2
      var podLabel = variant.option3
      var frame = KMPod.frameOptions[podLabel]

      return `<a class="frame-thumb"
        onclick="KMPod.selectFrame('${podLabel}');return false;"
        href="?variant=${variant.id}"
        data-variant-id="${variant.id}"
        data-pod-media="${podMedia}"
        data-pod-size="${podSize}"
        data-pod-label="${podLabel}"
        title="${podMedia} / ${podSize} / ${podLabel} frame"
        ><img src="${frame.image}" alt="${frame.title}"></a>`
    })

    // HACK: picker array is reversed to show "no frame" option last
    pickerHtml.reverse()

    $('.pod-frame-picker')
      .html(`<div class="frame-options">${pickerHtml.join('\n')}</div>`)
      .show()
  },

  filterFrameOptions: function (selectedVariantId) {
    console.log('filterFrameOptions', selectedVariantId)
    var selectedMedia = $('select[data-option=option1]').val()
    var selectedSize = $('select[data-option=option2]').val()

    // Hide all variant options
    $('[data-variant-id]').hide()

    // Then show options for selected media & size
    $(`[data-pod-media='${selectedMedia}'][data-pod-size='${selectedSize}']`).show()

    $('[data-variant-id]').removeClass('selected')
    $(`[data-variant-id="${selectedVariantId}"]`).toggleClass('selected')
  },

  // This function must always return a variant
  selectVariant: function (variant) {
    console.log('selectVariant', variant)
    // TODO: can this be done elsewhere? and ideally only once?
    $('select[data-option=option3]').hide()

    // If for some reason a variant is not available, disable the buy button
    if (variant && variant.available === false) {
      $('#AddToCart').prop('disabled')
      return variant
    }

    // If variant is null then the customer probably chose a combination of options that doesn't exist
    // ie. canvas with a frame or extra-small canvas etc.
    if (variant === null) {
      if (KMPod.isCanvas()) {
        // If canvas was chosen, try to find a suitable replacement
        var replacementVariant = KMPod.findReplacement()
        if (replacementVariant) {
          return KMPod.selectVariant(replacementVariant)
        }
      }

      // If not canvas or replacement couldn't be found, default to first variant
      // We think this is better than disabling the buy button and making the customer wonder what went wrong
      return KMPod.selectVariant(window.productVariants[0])
    }

    // sanity check. this check probably isn't necessary
    if (KMPod.isVendorKmg(window.product)) {
      KMPod.filterFrameOptions(variant.id)
      KMPod.updatePageDescription(variant)
      $('#productSelect-product-template-pod').val(variant.id)
    }

    return variant
  },

  selectFrame(podLabel) {
    $('select[data-option=option3]').val(podLabel).trigger('change')
  },

  updatePageDescription: function (variant) {
    var metaFields = window.variantMetafields[variant.id]
    var productDimensionsCm = metaFields['product-dimensions-cm']
    var imageDimensionsCm = metaFields['image-dimensions-cm']
    var productDescription = metaFields['product-description']

    var productSummary = []
    productSummary.push(KMPod.toTitleCase(productDescription))
    productSummary.push(`Product size: ${productDimensionsCm}`)
    productSummary.push(`Image area: ${imageDimensionsCm}`)

    $('#km-product-summary').remove()
    var html = '<div id="km-product-summary" class="km-product-summary">' + productSummary.join('<br>') + '</div>'
    $('.product__images').append(html)
  },

  isVendorKmg: function (product) {
    if (product && product.vendor) {
      return product.vendor.match(/king.*mcgaw/i)
    } else {
      throw 'Product is missing. Cannot continue.'
    }
  },

  toTitleCase: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  },

  isCanvas: function () {
    return $('select[data-option=option1]')
      .val()
      .match(/canvas/)
  },

  findReplacement: function () {
    var productType = $('select[data-option=option1]').val()
    var productSize = $('select[data-option=option2]').val()

    return _.find(productVariants, function (variant) {
      return variant.option1 == productType && variant.option2 == productSize
    })
  }
}
